const styles = theme => ({
  header: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#000',
    marginLeft: '8px',
  },
})

export default styles
